import type { Definition } from '../../../schema/frameworks/entry.js';
import { DefinitionEntity, type IDefinitionService, InternalError, NotFoundError } from '../../domain/entry.js';

const loadDefinitionAsync: IDefinitionService['loadDefinitionAsync'] = async (product) => {
  try {
    const exports = await import('@svenskaspelab/poolbetting/core/domain');

    switch (product) {
      case 'Powerplay':
        return new DefinitionEntity(exports.Powerplay);
      default:
        return undefined;
    }
  } catch (error: unknown) {
    if (error instanceof NotFoundError) {
      throw error;
    }

    throw new InternalError(`Error while loading definition, product: ${product}`, { cause: error });
  }
};

const resolveDefinitionAsync: IDefinitionService['resolveDefinitionAsync'] = async (product) => {
  let resolvedProduct: Definition['moduleEngine'];

  switch (product) {
    case 'TopptipsetExtra':
    case 'TopptipsetStryk':
      resolvedProduct = 'Topptipset';
      break;
    default:
      resolvedProduct = product;
  }

  return loadDefinitionAsync(resolvedProduct);
};

/**
 * Service for loading the definition for a given product.
 *
 * @returns Service to handle engine definition details
 */
export function definitionService(): IDefinitionService {
  return {
    loadDefinitionAsync,
    resolveDefinitionAsync,
  };
}
